// Gasto por org (Orión GET /superadmin/costos). Solo el dueño de la plataforma:
// el servidor exige rol thot_admin entrando desde brainstream/ucognet (403 si no).

import { orionGet } from '@/lib/api';

export type Proveedor = 'openai' | 'meta_whatsapp' | 'twilio' | 'elevenlabs';

export type CategoriaGasto = {
  etiqueta: string;
  proveedor: Proveedor | string;
  usd: number;
  cantidad: number;
  unidad: string;
  eventos: number;
  sin_costo: number;
};

export type GastoOrg = {
  org_id: string;
  nombre: string;
  total_usd: number;
  sin_costo: number;
  categorias: Record<string, CategoriaGasto>;
};

export type FacturaMeta = {
  waba_id: string;
  orgs: string[];
  nombre?: string | null;
  moneda?: string | null;
  con_forma_de_pago?: boolean;
  total?: number;
  por_categoria?: Record<string, { mensajes: number; costo: number }>;
  error?: string | null;
};

export type ResumenGasto = {
  desde: string;
  hasta: string;
  tipo_de_cambio_mxn: number | null;
  total_usd: number;
  por_proveedor: Partial<Record<Proveedor, number>>;
  orgs: GastoOrg[];
  por_dia: { dia: string; proveedor: Proveedor | string; usd: number }[];
  facturas_meta?: FacturaMeta[];
  tarifas: { whatsapp_usd_mx?: Record<string, number>; whatsapp_vigente_desde?: string; elevenlabs_usd_por_credito?: number | null };
};

export function getResumenGasto(desde: string, hasta: string): Promise<ResumenGasto> {
  const q = new URLSearchParams({ desde, hasta });
  return orionGet<ResumenGasto>(`/superadmin/costos?${q}`);
}
